import {httpService} from "@/modules/common/services";
import {appsService} from "@/modules/appMarket/services/appsService";


const fetchMeetings = async (start, end, staffUids) => {
  const data = {
    start: start,
    end: end,
    staff_uids: staffUids.join(', '),
    new_calendar: true
  }
  return await httpService.get('calendar/items', data)
}

const _waitForImportToFinish = async (app_uri, staff_id) => {
  let account = {}
  let count = 0;
  while (!account.did_import_finish && count < 4) {
    account = await appsService.getSyncAccount(app_uri, staff_id)
    if (!account) {
      return
    }
    if (!account.did_import_finish) {
      await new Promise(res => setTimeout(res, 1500))
    } else {
      localStorage.removeItem(`api_uri_${staff_id}`)
    }
    count++
  }
}

const fetchSyncMeetings = async (start, end, staff_id) => {
  const data = {
    start: start,
    end: end,
    staff_id,

  }
  const app_uri = localStorage.getItem(`api_uri_${staff_id}`)
  if (app_uri) {
    await _waitForImportToFinish(JSON.parse(app_uri), staff_id)
  }

  let result = await httpService.get('calendar/synced_items', data)
  while (result.status === 'accepted') {
    data["poll"] = true
    data["come_back_in"] = result.come_back_in
    await new Promise(res => setTimeout(res, result.come_back_in * 1000))
    result = await httpService.get('calendar/synced_items', data)
  }
  return result
}

export const schedulerService = {
  fetchMeetings,
  fetchSyncMeetings
}
